{
  "login": "Login",
  "password": "Hasło",
  "recoveryPassword": "Przypomnij hasło",
  "recoveryPasswordText": "Podaj swój login, aby przypomnieć hasło.",
  "signIn": "Zaloguj się",
  "signInText": "Użyj swoich danych, aby się zalogować.",
  "buttons": {
    "signIn": "Zaloguj się",
    "password": "Przypomnij hasło",
    "recoveryPassword": "przypomnij hasło",
    "backToLogin": "wróć do widoku logowania"
  }
}
